import * as React from 'react';

const SvgNavFolderFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M22 5h-9.53l-1.68-2H2v18h20V5Z" })
);

export { SvgNavFolderFill as default };
//# sourceMappingURL=NavFolderFill.es.js.map
